// Feature 298 — the translator the shared kitchen modules take as a parameter.
//
// These modules are pure and used by two surfaces (kitchen display, staff app),
// each with its own translation library: they never import one. The caller
// passes its own `t`; the type is declared here and erased at compile time.

export type SharedT = (key: string, fallback: string, values?: Record<string, unknown>) => string;

/**
 * No translator: the source text, placeholders filled in. For callers that
 * have none (unit tests, the board defaults kept as a constant).
 */
export const sourceT: SharedT = (_key, fallback, values) =>
  fallback.replace(/\{\{(\w+)\}\}/g, (match, name: string) =>
    values && Object.prototype.hasOwnProperty.call(values, name) ? String(values[name]) : match,
  );
